import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SEO } from './SEO';

export const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO />
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};